import { errorStatusMessage } from './errorStatusMessage';

export const locale = {
  ...errorStatusMessage,

  events: {
    title: 'Evento',
    type: 'Tipo de evento',
    location: {
      country: 'País/Región',
    },
    tournament: 'Torneo',
    sport: 'Deporte',
    bet: {
      selection: 'Apuesta a',
      odds: 'Cuota',
      outcome: 'Resultado',
    },
    result: {
      score: 'Marcador final',
    },
  },
  securePassword: 'Generar contraseña segura',

  changePassword: 'Cambia la contraseña',
  changeMyPassword: 'Cambiar Mi Contraseña',

  logout: 'Cerrar sesión',
  transferOfFunds: 'Transferencia de fondos',
  withdrawalOfFunds: 'Retiro de fondos',

  agentPlatfrom: 'Plataforma de agentes',
  email: 'Correo electrónico',
  phone: 'Teléfono',
  password: 'Clave',
  login: 'Acceso',
  logIn: 'Acceso',
  other: 'Otro',
  username: 'Nombre de usuario',
  user: 'Usuario',
  language: 'Idioma',
  confirmNewPassword: 'Confirmar nueva contraseña',
  changeMyPassword: 'Cambiar mi contraseña',
  statuses: {
    1: 'Victoria',
    2: 'Perdido',
    3: 'Regreso',
  },

  generalReport: 'Informe General',
  depositsAndWithdrawals: 'Depósitos y retiros',
  playerAndAgentDetail: 'Detalle por Jugador y Agente',
  playerDetail: 'Detalle por Jugador',
  agents: 'Agentes',
  agent: 'Agente',
  vendor: 'Proveedor',
  owner: 'propietario',
  dob: 'Fecha de nacimiento',
  confirmPassword: 'Confirmar contraseña',

  emtretenimiento: 'Somos emtretenimiento',

  users: 'Usuarios',
  seeAll: 'Ver todo',
  seeAgents: 'Ver agentes',
  seePlayers: 'Ver jugadores',
  createAgent: 'Crear agente',
  createPlayer: 'Crear jugador',
  reports: 'Informes',
  financialReports: 'Reportes financieros',
  general: 'General',
  cashDepositsWithdrawals: 'Efectivo (depósitos y retiros)',
  playerReports: 'Informes de jugadores',
  playerHistory: 'Historial del jugador',
  detailByPlayer: 'Detalle por jugador',
  sportsBets: 'Apuestas deportivas',
  finance: 'Finanzas',
  myDebtAccount: 'Depositos/Retiros Agentes',
  accountBalance: 'Saldo de la cuenta',
  howToStart: 'Cómo empezar',
  onlyPersonalHigherTransfers: 'Movimientos de/a mi cuenta',
  deposits: 'Depósitos',
  withdrawals: 'Retiros',
  onlyUserTransfers: 'Mis operaciones',
  actualBalance: 'Balance actual',
  totalDeposit: 'Total depósitos',
  totalWithdraw: 'Total retiros',
  saldo: 'Saldo',

  search: 'Búsqueda',
  newAgent: 'Nuevo agente',
  newPlayer: 'Nuevo jugador',
  player: 'Jugador',

  allUsers: 'Todos',
  cashierAgent: 'Cajero - agente',
  players: 'Jugadores',
  disabled: 'Desactivado',
  user: 'Usuario',
  balance: 'Balance',
  operations: 'Operaciones',
  actions: 'Comportamiento',
  records: 'Registros',
  recordsOnPage: 'Mostrar en la página',
  elementsOnPage: 'Elementos en la página',

  withdrawal: 'Retiro',
  deposit: 'Depósito',
  topup: 'Depósito',
  cancel: 'Cancelar',
  save: 'Crear',

  name: 'Nombre',
  filter: 'Filtro',
  acceptFilter: 'Aceptar filtro',

  surname: 'Apellido',
  nameAndSurname: 'Nombre y apellido',

  withdrawalAllowed: 'Permitir <span>retiros</span> para sus agentes y jugadores',
  depositAllowed: 'Permitir <span>depósitos</span> para sus agentes y jugadores',
  canCreateOnlyPlayers: 'Permitir que solo se creen <span>jugadores</span>',

  createSuccess: 'Éxito',
  amount: 'Monto',

  disable: 'Deshabilitar',
  edit: 'Editar',
  userEdit: 'Editar',
  informations: 'Informaciones',
  id: 'ID',
  accept: 'Aceptar',
  disableUser: 'Deshabilitar usuario',
  acceptDisableUser: 'Sí, deshabilitar usuario',
  acceptEnableUser: 'Sí, habilitar usuario',
  disableDescription: 'Está seguro de que desea deshabilitar el reproductor <br/> con nombre de usuario',
  enableDescription: 'Está seguro de que desea habilitar el reproductor <br/> con nombre de usuario',
  wantToCreateAgent: 'Está seguro de que desea crear un agente <br/> con nombre de usuario',
  wantToCreatePlayer: 'Está seguro de que quieres crear un reproductor <br/> con nombre de usuario',

  modifyAgent: 'Modificar agente',
  information: 'Información',
  hierachy: 'jerarquía',
  currency: 'Divisa',
  creationDate: 'Fecha de creación',
  modificationDate: 'Fecha de modificación',
  enable: 'Habilitar',
  enableUser: 'Habilitar usuario',
  close: 'Cerrar',
  noResults: 'No se han encontrado resultados',

  today: 'Este Dia',
  yesterday: 'El dia de ayer',
  lastWeek: 'La semana pasada',
  lastMonth: 'El mes pasado',
  lastYear: 'El año pasado',
  dateFrom: 'Fecha de',
  dateTo: 'Fecha hasta',
  local: 'Local',
  utc: 'UTC',
  dateUntil: 'Fecha hasta',
  help: 'Ayuda',
  show: 'Espectáculo',
  directOnly: 'Solo directo',
  timeZoneMsg:
    'La zona horaria local tiene en cuenta la fecha y la hora que ha configurado en su dispositivo. La zona horaria UTC 00:00 es un estándar de tiempo universal. Si selecciona la opción "Local", se tendrá en cuenta la hora de su país, y si selecciona la opción "UTC", se tendrá en cuenta la hora estándar universal.',
  10: '10',
  total_bet_count: 'Recuento total de apuestas',
  total_bet: 'Apuesta total',
  total_won: 'Total ganado',
  betCount: 'Recuento de apuestas',
  betAmount: 'monto de la apuesta',
  winAmount: 'Cantidad ganada',
  provider: 'Proveedor',

  searchIn: 'Busca en',
  higher: 'Más alto',
  transaction: 'Transacción',
  transactionType: 'Tipo de transacción',
  date: 'Fecha',
  operation: 'Operación',
  transitionType: 'Tipo de transición',
  agentInitiator: 'Agente iniciador',
  initiator: 'Iniciador',
  destinationAgent: 'Agente de destino',

  reportsGeneral: 'Informes generales',
  playerReportsGeneral: 'Informes de jugadores generales',
  sportBets: 'Apuestas deportivas',
  amountIn: 'Cantidad en',
  amountOut: 'importe',
  total: 'Total',
  byProvider: 'Por proveedor',
  myOperations: 'Mis operaciones',
  result: 'Resultado',
  possibleGain: 'Posible ganancia',

  gameType: 'Tipo de juego',
  statusBet: 'Apuesta de estado',
  type: 'Tipo',
  win: 'Victoria',
  bet: 'Apuesta',
  betId: 'ID de apuesta',
  refund: 'Reembolso',
  liveCasino: 'Casino en vivo',
  fiable: 'Fiable',
  all: 'Todos',
  slots: 'Tragamonedas',
  status: 'Estado',
  prevBalance: 'Saldo antes',
  balanceBefore: 'Saldo antes',
  balanceAfter: 'Saldo después',
  prevBefore: 'Saldo ante',
  afterBalance: 'Saldo después',
  userId: 'Identificación de usuario',
  couponId: 'identificación del cupón',
  wait: 'Esperar',
  return: 'Devolver',
  loss: 'Pérdida',
  sold: 'Vendido',
  isExpress: 'es expreso',
  createdAt: 'Creado en',
  totalCoeff: 'Coeficiente total',
  fromUser: 'Del usuario',
  toUser: 'Al usuario',
  from: 'Del',
  to: 'Al',
  role: 'Rol',

  subagents: 'Subagentes',
  newPassword: 'Nueva contraseña',
  oldPassword: 'Contraseña antigua',
  repeatPassword: 'Repita la contraseña',
  passwordsDontMatch: '¡Las contraseñas no coinciden!',

  total_income: 'Ingreso total',
  incomeAmount: 'Cantidad de ingresos',

  enterTextInLowercaseOnly: 'Introducir texto sólo en minúsculas',
  lastMovements: 'Últimos movimientos',
  parent: 'Padre',
  userTree: 'Árbol de usuarios',
  currentUser: 'usuario actual',
  playersCount: 'Los jugadores cuentan',

  changePermissions: type => `Edición de permisos: ${type} `,
  changePermissionsCasino: 'Permission edit: Casino',
  changePermissionLiveCasino: 'Permission edit: Live Casino',
  changePermissionSport: 'Permission edit: Sport',
  showTheSelectedCategoryForUser: 'Mostrar la categoría seleccionada para el usuario',
  hideTheSelectedCategoryForUser: 'Ocultar la categoría seleccionada para el usuario',
  permissionsDetails: 'Detalles de permisos',
  casino: 'Casino',
  sport: 'Deportivas',
  permissions: 'Permisos',
  copyPermissions: 'Copiar permisos a usuarios secundarios',
  dontHavePermissionToLogin: `No tengo permiso para iniciar sesión`,

  paymentStatuses: {
    0: 'Depósito',
    1: 'Retiro',
  },
  notification: 'Notificación',
  depositMessage: (name, role) => `El ${role} ${name} ha realizado un depósito a su saldo`,
  withdrawalMessage: (name, role) => `El ${role} ${name} ha retirado dinero de su saldo`,

  new: 'Nuevo',

  WON: 'Ganado',
  CASHED_OUT: 'Retirado',
  RETURNED: 'Devuelto',
  LOST: 'Perdido',
  ACCEPTED: 'Aceptado',
  virtualGames: 'Juegos virtuales',
  logIn: 'Acceso',
  editAccount: 'Editar Cuenta',

  january: 'Enero',
  february: 'Febrero',
  march: 'Marzo',
  april: 'Abril',
  may: 'Puede',
  june: 'Junio',
  july: 'Julio',
  august: 'Agosto',
  september: 'Septiembre',
  october: 'Octubre',
  november: 'Noviembre',
  december: 'Diciembre',

  usersBy: 'Usuarios por',

  All: 'Todos',
  Single: 'Unico',
  Express: 'Expreso',
  Accepted: 'Aceptado',
  CashedOut: 'Retirado',
  Returned: 'Devuelto',
  Lost: 'Perdido',
  Won: 'Ganado',
  totalCoefficient: 'Coeficiente total',
  toUsername: 'Al nombre de usuario',
  tree: 'Árbol',
  hideMenu: 'Ocultar',
  showMenu: 'Mostrar',
};
